export default __webpack_public_path__ + "static/media/tiga.b4ed32cc.svg";